<script>
import resourceSelect from '../../mixins/resourceSelect';

export default {
  mixins: [resourceSelect],

  data() {
    return {
      route: 'api.shops.index',
      defaults: {
        trackBy: 'id',
        label: 'name',
        placeholder: 'Sélectionnez une boutique',
      },
    };
  },
};
</script>